import { BookOpen, ChevronRight } from "lucide-react";
import type { SearchArticle } from "src/api/search";
import { SearchSnippet } from "src/components/GlobalSearch/SearchPopper/SearchSnippet";
import { highlightPhrase } from "src/helpers/highlightSearch";

type ArticleViewProps = {
	article: SearchArticle;
	searchValue: string;
};

// ponytail: bez czasu czytania i tagu (wyszukiwarka zwraca tylko działy) — dodać, gdy backend je da
export function ArticleView({ article, searchValue }: ArticleViewProps) {
	const snippet = article.snippets?.[0];

	return (
		<div className="article-search-item">
			<span className="article-search-item__icon">
				<BookOpen className="icon-small" />
			</span>
			<div className="flex flex-col gap-4 min-w-0 flex-1">
				<span className="article-search-item__title text-ellipsis-1">
					{highlightPhrase(article.title, searchValue)}
				</span>
				{article.departments.length > 0 && (
					<span className="article-search-item__meta">
						{article.departments.join(" · ")}
					</span>
				)}
				{snippet && <SearchSnippet snippet={snippet} />}
			</div>
			<ChevronRight className="icon-small article-search-item__chevron" />
		</div>
	);
}
